import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendSiteMetadata } from "./api";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    sendSiteMetadata().catch(err => console.error('Failed to send site metadata:', err));
  }, [pathname]);

  return null;
};
